import React, { useState, forwardRef, useImperativeHandle } from "react";
import { Link } from "react-router-dom";
import { Offcanvas } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { addJob } from "../../../store/actions/Jobs/jobActions";

const AddJobComponent = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    regDate: new Date(),
    companyId: props?.companyId,
    company: props?.companyName,
    jobTitle: "",
    jobID: "",
    latestActionDate: new Date(),
    jobStartDate: null,
    jobEndDate: null,
    service: "",
    salary: 0,
    status: "LIVE",
  });
  const resetForm = () => {
    setFormData({
      companyId: props?.companyId,
      company: props?.companyName,
      jobTitle: "",
      latestActionDate: new Date(),
      jobStartDate: null,
      jobEndDate: null,
      salary: 0,
      status: "LIVE",
    });
    setErrors({});
  };

  const [errors, setErrors] = useState({});
  const [addJobModal, setAddJob] = useState(false);

  useImperativeHandle(ref, () => ({
    showAddJobModal() {
      setAddJob(true);
    },
  }));

  const validate = () => {
    const newErrors = {};
    // Check nested contact fields
    if (!formData.jobTitle?.trim()) {
      newErrors.jobTitle = "Please enter job title.";
    }

    if (!formData.jobID?.trim()) {
      newErrors.jobID = "Please enter job id.";
    }
    

    if (!formData.jobStartDate) {
      newErrors.jobStartDate = "Please enter job start date.";
    }

    if (!formData.jobEndDate) {
      newErrors.jobEndDate = "Please enter job end date.";
    }

    if (!formData.service) {
      newErrors.service = "Please enter service.";
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.error("Please fill all required fields.");
    }

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (field, value, nested = null) => {
    if (nested) {
      setFormData((prev) => ({
        ...prev,
        [nested]: { ...prev[nested], [field]: value },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [field]: value }));
    }
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      dispatch(addJob(formData, setAddJob, props.token));
    }
  };

  return (
    <Offcanvas
      show={addJobModal}
      onHide={() => setAddJob(false)}
      className="offcanvas-end customeoff"
      placement="end"
    >
      <div className="offcanvas-header">
        <h5 className="modal-title">{props.Title}</h5>
        <button
          type="button"
          className="btn-close"
          onClick={() => setAddJob(false)}
        >
          <i className="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div className="offcanvas-body">
        <form onSubmit={handleSubmit}>
          <div className="row">
            {/* Company Name */}
            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Job Title <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={formData.jobTitle}
                onChange={(e) => handleInputChange("jobTitle", e.target.value)}
              />
              {errors.jobTitle && (
                <small className="text-danger">{errors.jobTitle}</small>
              )}
            </div>

            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Job ID <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={formData.jobID}
                onChange={(e) => handleInputChange("jobID", e.target.value)}
              />
              {errors.jobID && (
                <small className="text-danger">{errors.jobID}</small>
              )}
            </div>

            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Salary <span className="text-danger">*</span>
              </label>
              <input
                type="number"
                min={0}
                className="form-control"
                value={formData.salary}
                onChange={(e) => handleInputChange("salary", e.target.value)}
              />
              {errors.salary && (
                <small className="text-danger">{errors.salary}</small>
              )}
            </div>

            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Company name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                disabled
                value={formData.company}
              />
            </div>

            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Service <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={formData.service}
                onChange={(e) => handleInputChange("service", e.target.value)}
              />
              {errors.service && (
                <small className="text-danger">{errors.service}</small>
              )}
            </div>

            {[
              { label: "Job Start Date", field: "jobStartDate" },
              { label: "Job End Date", field: "jobEndDate" },
            ].map(({ label, field }) => (
              <div className="col-xl-6 mb-3" key={field}>
                <label className="form-label">{label} <span class="text-danger">*</span></label>
                <DatePicker
                  className="form-control"
                  selected={formData[field]}
                  onChange={(date) => handleInputChange(field, date)}
                />
                {errors[field] && (
                  <small className="text-danger">{errors[field]}</small>
                )}
              </div>
            ))}

            {/* Status */}
            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Status <span className="text-danger">*</span>
              </label>
              <select
                className="form-control"
                value={formData.status}
                onChange={(e) => handleInputChange("status", e.target.value)}
              >
                <option value=""></option>
                <option value="LIVE">LIVE</option>
                <option value="ARCHIVED">ARCHIVED</option>
                <option value="CLOSED">CLOSED</option>
              </select>
              {errors.status && (
                <small className="text-danger">{errors.status}</small>
              )}
            </div>
          </div>
          <button type="submit" className="btn btn-primary">
            Submit
          </button>
          <Link
            to={"#"}
            onClick={() => {
              resetForm();
              setAddJob(false);
            }}
            className="btn btn-danger ms-2"
          >
            Cancel
          </Link>
        </form>
      </div>
    </Offcanvas>
  );
});

export default AddJobComponent;
